import { SelectField, type SelectFieldProps } from '@/components';
import { type FieldValues, type Path, useFormContext } from 'react-hook-form';
import { AccountingTypeLabelModifier, accountingType } from '../../models';

type Props<T extends FieldValues> = {
  name: Path<T>;
  label: string;
  hint?: string;
} & Pick<SelectFieldProps<T>, 'shouldCoexistOnChange' | 'onChange' | 'width'>;

export const AccountingTypeOptionSelectField = <T extends FieldValues>({
  name,
  label,
  hint,
  shouldCoexistOnChange,
  width = 160,
  onChange,
}: Props<T>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<T>();

  return (
    <SelectField
      name={name}
      label={label}
      hint={hint}
      control={control}
      options={accountingType.options.map((value) => ({
        value,
        label: AccountingTypeLabelModifier[value],
      }))}
      errors={errors}
      width={width}
      shouldCoexistOnChange={shouldCoexistOnChange}
      onChange={onChange}
    />
  );
};
